import type { CheckoutStore } from '@stores/checkout/interfaces'
import type { Order } from '@brighterly/lib-core-types/orders/interfaces'

import { getOrder } from '@utils/stores/checkout/active-order'

export const oneTimePaymentGetters = {
  getOrderTotal: (state: CheckoutStore): Order['total'] => getOrder(state)?.total || 0,
}
